import React from "react";
import {
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const FinancialInfoProvided = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">contributor:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    {milestone.details.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>Financial information</TimelineSectionTitle>
        <TimelineChangeList>
          {milestone.details.map((detail) => (
            <TimelineChangeRow key={detail.type}>
              <span className="timeline-change-label">{detail.type}:</span>
              <span className="timeline-change-value">
                {detail.type === 'Origination Date' ?
                  `${detail.detail.substring(0, 10)}`
                : detail.type === 'Loan Amount' ?
                  `$${detail.detail.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}`
                : detail.type === `Interest Rate` ?
                  `${detail.detail}%`
                :
                  `${detail.detail}`
                }
              </span>
            </TimelineChangeRow>
          ))}
        </TimelineChangeList>
      </TimelineSection>
    }
  </TimelineContent>
)

export default FinancialInfoProvided
